import React from 'react';

import { Box, Typography, styled } from '@mui/material';

import { ExportStatus } from '../../types';

const ERROR_BG_COLOR = '#FFEFEF';

const ErrorBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: ERROR_BG_COLOR,
  borderRadius: theme.shape.borderRadius,
}));

interface ExportErrorDetailsProps {
  exportStatus: ExportStatus;
}

export const ExportErrorDetails = ({ exportStatus }: ExportErrorDetailsProps) => {
  return (
    <Box>
      <Typography color="error" variant="body1" sx={{ mb: 2 }}>
        Export Failed
      </Typography>

      <ErrorBox>
        {exportStatus.export_id && (
          <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
            Export ID: {exportStatus.export_id}
          </Typography>
        )}
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          Error Details: {exportStatus.message}
        </Typography>
      </ErrorBox>

      <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
        {exportStatus.export_id 
          ? 'Please share the error information with the Customer Support team. Include the Export ID and error details above when contacting support.'
          : 'Please share the error details above with the Customer Support team when contacting support.'}
      </Typography>

      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Common Troubleshooting Tips
      </Typography>
      <Box component="ul" sx={{ pl: 2, m: 0 }}>
        <Box component="li" sx={{ mb: 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Check your GruntWorx dashboard to see if files were partially uploaded
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Verify your GruntWorx integration settings
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Try exporting fewer files at once
          </Typography>
        </Box>
        <Box component="li">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Ensure all files have proper client assignments
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}; 